function debugEnabled() {
  try {
    return (
      typeof window !== "undefined" &&
      window.localStorage &&
      window.localStorage.getItem("EMOTII_DEBUG") === "1"
    );
  } catch (e) {
    return false;
  }
}

function emit(level, ns, args) {
  if (level === "debug" && !debugEnabled()) return;
  const fn =
    level === "error" ? console.error : level === "warn" ? console.warn : console.log;
  fn(`[${ns}]`, ...args);
}

export function createLogger(ns) {
  return {
    error: (...args) => emit("error", ns, args),
    warn: (...args) => emit("warn", ns, args),
    info: (...args) => emit("info", ns, args),
    debug: (...args) => emit("debug", ns, args),
  };
}

export function logCoupling(phase, fields = {}) {
  const parts = Object.entries(fields)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${v}`)
    .join(" ");
  console.log(`[COUPLING] phase=${phase} side=web ${parts}`.trim());
}

export default createLogger;
